import React from "react";
import { Typography } from "@mui/material";

function WrapperState({ data }) {
  return (
    <>
      {data.state === "تایید" ? (
        <Typography variant="h6" color="modules.checked">
          {data.state}
        </Typography>
      ) : data.state === "در حال بررسی" ? (
        <Typography variant="h6" color="modules.pending">
          {data.state}
        </Typography>
      ) : data.state === "رد شده است" ? (
        <Typography variant="h6" color="error.main">
          {data.state}
        </Typography>
      ) : (
        ""
      )}
    </>
  );
}
export default WrapperState;
